export const TERME_ASYMETRIQUE_DESACTIVANT_default = [
    {
        strike: 1.2,
        ko:	1.15
    },
    {
        ko:	1.15,
        strike: 1.2
    },
    {
    },
    {
        strike: 1.15,
        ko:	1.2
    },
    {
        strike: 1.15,
        ko:	1.2
    },
    {
    }
]


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/TermeAsymetriqueDesactivant.ts